import { setHours } from 'date-fns/setHours';
import { setMinutes } from 'date-fns/setMinutes';

export const MINUTES_IN_SLOT = 30;

const SLOTS_PER_DAY = (24 * 60) / MINUTES_IN_SLOT;

export function taskTimeOptions(): string[] {
  return Array.from({ length: SLOTS_PER_DAY }, (_, index) => {
    const minutes = index * MINUTES_IN_SLOT;
    const hours = String(Math.floor(minutes / 60)).padStart(2, '0');

    return `${hours}:${String(minutes % 60).padStart(2, '0')}`;
  });
}

export function atTime(day: Date, time: string): Date {
  const [hours, minutes] = time.split(':').map(Number);

  return setMinutes(setHours(day, hours ?? 0), minutes ?? 0);
}
